// If this ever throws it means that a precondition has been broken and we can't fulfill the request
export function impossible(tag: string): never {
  throw new Error(`Impossible: ${tag}`);
}

export function error(reason: string): never {
  throw new Error(reason);
}

// TODO set a lint
export function unimplemented(reason?: string): never {
  throw new Error(`Unimplemented: ${reason}`);
}

// The `never` parameter makes this a compile-time exhaustiveness check, but a
// type assertion (e.g. `assistant_type_id as AssistantId`) can smuggle an
// unhandled value through at runtime — throwing turns that into a loud error
// instead of silently returning the evidence as if it were a valid result.
export function unreachable(evidence: never): never {
  throw new Error(`Unreachable: unhandled value ${JSON.stringify(evidence)}`);
}

export function unsupported(reason?: string): never {
  throw new Error(`Unsupported: ${reason}`);
}
